import { createTheme } from '@mui/material'

export default createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '&::-webkit-scrollbar': {
          width: 0,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiCard: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          borderRadius: 4,
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          'flex': 'auto',
          '&::-webkit-scrollbar': {
            width: 8,
          },
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: '1.6rem 1.2rem',
          justifyContent: 'flex-end',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        type: 'number',
        variant: 'standard',
        inputMode: 'numeric',
        fullWidth: true,
      },
      styleOverrides: {
        root: {
          'color': 'black !important',
          '& .Mui-disabled': {
            color: 'black !important',
            WebkitTextFillColor: 'black',
          },
          'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
            appearance: 'none',
            WebkitAppearance: 'none',
            margin: 0,
          },
          'input[type=number]': {
            appearance: 'textfield',
            MozAppearance: 'textfield',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& :focus': {
            backgroundColor: 'transparent !important',
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          maxHeight: '24rem',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          'display': 'flex',
          'alignItems': 'start',
          'gap': '0.2rem',
          'marginTop': '0.4rem',
          '& > svg': {
            width: '1.2rem',
          },
          '& > span': {
            lineHeight: 0,
            display: 'flex',
            flexFlow: 'column nowrap',
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontFamily: 'Roboto',
          fontWeight: 'bold',
          minWidth: '8rem',
          minHeight: '2.8rem',
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        positionEnd: {
          paddingRight: '0.4rem',
        },
      },
    },
  },
})
